import { Box, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { mergeSxProps } from "@src/appV2/redesign/system/ui-components";
import { forwardRef } from "react";

interface PageContentProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

function PageContentBase(props: PageContentProps, ref: React.Ref<HTMLDivElement>) {
  const { children, sx } = props;
  return (
    <Box
      ref={ref}
      sx={mergeSxProps(
        {
          display: "flex",
          flexDirection: "column",
          paddingX: 5,
          paddingBottom: 4,
          overflowY: "auto",
          overflowX: "hidden",
          flexGrow: 1,
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        sx
      )}
    >
      {children}
    </Box>
  );
}

export const PageContent = forwardRef(PageContentBase);

PageContent.displayName = "PageContent";
